// for p tag opacity
gsap.registerPlugin(ScrollTrigger);

  const paragraphs = document.querySelectorAll('p');
  
  paragraphs.forEach((paragraph, index) => {
    gsap.timeline({
      scrollTrigger: {
        trigger: paragraph,
        start: "top 60%",
        end: "top 70%",
        toggleActions: "play none none none"
      }
    })
    .to(paragraph, {
      opacity: 1,
      duration: 0.1,
      ease: "none",
    });
  });

// for a magnetic button start------------------------------------------------------------------------------------------------------
// Check window width before applying JavaScript
if (window.innerWidth > 750) {
    const btns = document.querySelectorAll(".btns button, .btns a");

    btns.forEach((btn) => {
        btn.addEventListener("mousemove", function (e) {
            const position = btn.getBoundingClientRect();
            const x = e.pageX - position.left - position.width / 2;
            const y = e.pageY - position.top - position.height / 2;

            // Assuming you want to apply the transform to the button or anchor tag itself
            btn.style.transform = "translate(" + x * 0.12 + "px, " + y * 0.2 + "px)";
        });

        btn.addEventListener("mouseout", function (e) {
            btn.style.transform = "translate(0px, 0px)";
        });
    });

    const btns1 = document.querySelectorAll(".d-intro-btn-container a,.f-01-btns button,.f-01-btns a");

    btns1.forEach((btnn) => {
        btnn.addEventListener("mousemove", function (e) {
            const position = btnn.getBoundingClientRect();
            const x = e.pageX - position.left - position.width / 2;
            const y = e.pageY - position.top - position.height / 2;

            // Assuming you want to apply the transform to the button or anchor tag itself
            btnn.style.transform = "translate(" + x * 0.12 + "px, " + y * 0.003 + "px)";
        });

        btnn.addEventListener("mouseout", function (e) {
            btnn.style.transform = "translate(0px, 0px)";
        });
    });
}

// for magnetic button end----------------------------------------------------------------------------------------------------------




// Get the current page URL
    var currentPageUrl = window.location.href;

    // Get all anchor tags inside the navigation list
    var navigationLinks = document.querySelectorAll('#navigation a');

    // Loop through each link and check if its href matches the current page URL
    navigationLinks.forEach(function(link) {
        if (link.href === currentPageUrl) {
            // Add the "m-a" class to the link if it matches the current page URL
            link.classList.add('m-a');
        }
    });



// for loading bar start
document.addEventListener("DOMContentLoaded", function () {
  var iframe = document.getElementById("myIframe");
  var loadingBar = document.querySelector(".loading-bar");

  setTimeout(function () {
    loadingBar.style.opacity = "1"; // Fade in loading bar
    setTimeout(function() {
      loadingBar.style.opacity = "0"; // Fade out loading bar
      setTimeout(function() {
        loadingBar.style.display = "none"; // Hide loading bar after transition
        iframe.style.opacity = "1"; // Fade in iframe
      }, 1); // Wait for the loading bar transition to complete
    }, 2000); // Wait for 3 seconds before fading out loading bar
    iframe.style.display = "block"; // Show iframe
  }, 2000); // Wait for 3 seconds before showing iframe
});


$(document).ready(function(){
    // Function to handle dot click
    $('.dots .dot').click(function() {
        var index = $(this).index();
        $('.myslider .item').hide();
        $('.myslider .item').eq(index).show();
        $('.dots .dot').removeClass('active');
        $(this).addClass('active');
    });
    
    // Function to auto slide
    function slideTestimonial() {
        $(".myslider .item").first().slideUp(1000, function(){
            $(this).appendTo($(".myslider")).slideDown(0);
        });
        
        var activeDot = $('.dots .dot.active');
        var nextDot = activeDot.next('.dot');
        if (nextDot.length === 0) {
            nextDot = $('.dots .dot').first();
        }
        activeDot.removeClass('active');
        nextDot.addClass('active');
    }
    
    // Set interval for auto sliding
    setInterval(slideTestimonial, 15000);
});




// for header bottom shadow
window.addEventListener('scroll', function() {
    var header = document.getElementById('header');
    var scrollPosition = window.scrollY;

    if (scrollPosition > 0) {
        header.classList.add('shadow');
    } else {
        header.classList.remove('shadow');
    }
});


// for get to the product page spline  
window.onload = function() {
    var element = document.getElementById("myLink");
    if (element) {
        element.scrollIntoView();
    }
};







$(".tabs a[data-toggle]").on("click", function (e) {
  e.preventDefault(); // prevent navigating
  var selector = $(this).data("toggle"); // get corresponding element
  $(".tabs-content div").hide();
  $(selector).show();
});

$(".tabs > a:first-child").addClass("active");
$(".tabs a").click(function () {
  var index = $(this).index();
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
  } else {
    $(".myLink").removeClass("active");
    $(this).addClass("active");
  }
});

document.addEventListener('DOMContentLoaded', function () {
    const hamburgerMenu = document.querySelector('.hamburger-menu');
    const menuContent = document.querySelector('.hamburger-menu-content');
    const body = document.querySelector('body'); 

    hamburgerMenu.addEventListener('click', () => {
        hamburgerMenu.classList.toggle('open');
        menuContent.classList.toggle('open');
       body.classList.toggle('overflow');
    });
});

const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", (event) => {
        const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");
        
        if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
            currentlyActiveAccordionItemHeader.classList.toggle("active");
            currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
        }

        accordionItemHeader.classList.toggle("active");
        const accordionItemBody = accordionItemHeader.nextElementSibling;
        if (accordionItemHeader.classList.contains("active")) {
            accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px"; // Set max-height to scroll height
        } else {
            accordionItemBody.style.maxHeight = 0;
        }
    });
});



